import { IPaymentConfig, IPaymentConfigRaw } from '~/shared/types/configTypes'

export const getPaymentConfigFromConfigRaw = (
  paymentConfig: IPaymentConfigRaw,
): IPaymentConfig => ({
  stripe: {
    accountId: paymentConfig.stripe.account_id,
    accountName: paymentConfig.stripe.account_name,
    publicKey: paymentConfig.stripe.public_key,
  },
  primer: {
    enabled: paymentConfig.primer.enabled,
    applePayEnabled: paymentConfig.primer.apple_pay_enabled,
    googlePayEnabled: paymentConfig.primer.google_pay_enabled,
  },
})
